import { Component, OnInit } from '@angular/core';
import { CardService } from '../../services/card.service';
import { ActivatedRoute, Router } from '@angular/router';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'pa-account-kvkk',
  templateUrl: './account-kvkk.component.html',
  styleUrls: ['./account-kvkk.component.scss']
})
export class AccountKvkkComponent implements OnInit {

  contractUrl: string;

  constructor(private router: Router, private cardService: CardService, private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.contractUrl = environment.contractUrl + 'content?page=kvkk';
  }

}
